////const nativeImport = url => new Function('url', 'return import(url);')(url);

export default function importUtils() {
    return import(/* webpackIgnore: true */cpAppSet.baseSharedlUrl + "theme/vendors/intl-tel-input-2/js/utils.js?v=25.3.1");
}


